import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useUsersListQuery } from 'api';
import { GoBackButtonWithTitle, PageHeaderBoldTitle, Spinner } from 'components';
import { useCreateDraft } from 'hooks';
import { TaskStatus, UserStatus } from 'types';

import { CreateTaskForm } from '../../components';
import { defaultValuesAdapter } from './adapter';
import { ContentW, PageW } from './styled';

type LocationState = {
  status?: TaskStatus;
  assigneeId?: string;
};

export function CreateTaskPage(): ReactElement {
  const { t } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();

  const { draft, isLoading } = useCreateDraft();

  const { isLoading: isLoadingUsersList, usersList } = useUsersListQuery({
    status: [UserStatus.Active, UserStatus.Registered],
  });

  const status = (state as LocationState)?.status;
  const assigneeId = (state as LocationState)?.assigneeId;
  const defaultValues = defaultValuesAdapter({ draft, status, assigneeId });

  if (isLoading || isLoadingUsersList) {
    return <Spinner />;
  }

  return (
    <PageW>
      <GoBackButtonWithTitle
        title={t('common.back')}
        onClick={() => navigate(-1)}
        containerSx={{
          marginTop: 0,
          maxWidth: '100%',
        }}
      />
      <PageHeaderBoldTitle title={t('task.create.title')} />
      <ContentW>
        {draft && (
          <CreateTaskForm defaultValues={defaultValues} draftId={draft.id} usersList={usersList} />
        )}
      </ContentW>
    </PageW>
  );
}
